import { Edit } from '@mui/icons-material';
import { Button, FormControl, Grid, IconButton, Dialog, TextField, Typography, FormLabel } from '@mui/material'
import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types';
import { InfoContext } from '../../services/Context/Info/context';
import Coupon from '../../services/db/coupon';

function AddCoupon({ data = {} }) {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(data);
  const { data: { couponData }, setData } = useContext(InfoContext)
  const handleChange = async e => {
    setInfo(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }
  const handleAdd = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    new Coupon().addCoupon(info).then((r) => {
      if (info.id) {
        const ind = couponData.findIndex(el => el.id === info.id)
        if (ind !== -1) {
          let c = couponData.map(((el, _id) => (_id === ind ? info : el)))
          setData(p => ({ ...p, couponData: c }))
        }
      }
      else setData(p => ({ ...p, couponData: [...couponData, { ...info, id: r }] }))
      setInfo({});
      setOpen(false)
    })
  }
  return (
    <>
      {!data.id ?
        <Button
          color='secondary'
          variant='contained'
          onClick={() => setOpen(true)}
        >
          Add Coupon
        </Button> :
        <IconButton onClick={() => setOpen(true)}>
          <Edit />
        </IconButton>
      }
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <Grid container maxWidth={'md'} sx={{ backgroundColor: 'white' }} spacing={2} padding={2}>
          <Grid item xs={12}>
            <Typography>Add Coupon</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Title' size='small' fullWidth>
              <FormLabel>Title</FormLabel>
              <TextField
                size='small'
                name='title'
                value={info?.title}
                fullWidth
                onChange={handleChange}
                type='text'
                placeholder='Title'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Title' size='small' fullWidth>
              <FormLabel>Description</FormLabel>
              <TextField
                size='small'
                name='description'
                value={info?.description}
                fullWidth
                onChange={handleChange}
                type='text'
                placeholder='Description'
                multiline
                rows={4}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button variant='contained' color='primary' onClick={handleAdd}>Submit</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

AddCoupon.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
  }),
};

export default AddCoupon